var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModulesad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 4.16667C16.5747 3.875 15.558 3.75 14.583 3.75C12.958 3.75 11.208 4.08333 9.99967 5C8.79134 4.08333 7.04134 3.75 5.41634 3.75C3.79134 3.75 2.04134 4.08333 0.833008 5V17.2083C0.833008 17.4167 1.04134 17.625 1.24967 17.625C1.33301 17.625 1.37467 17.5833 1.45801 17.5833C2.58301 17.0417 4.20801 16.6667 5.41634 16.6667C7.04134 16.6667 8.79134 17 9.99967 17.9167C11.1247 17.2083 13.1663 16.6667 14.583 16.6667C15.958 16.6667 17.3747 16.9167 18.5413 17.5417C18.6247 17.5833 18.6663 17.5833 18.7497 17.5833C18.958 17.5833 19.1663 17.375 19.1663 17.1667V5C18.6663 4.625 18.1247 4.375 17.4997 4.16667ZM2.49967 15.4167V5.83333C3.41634 5.54167 4.41634 5.41667 5.41634 5.41667C6.53301 5.41667 8.02467 5.75833 9.16634 6.24167V15.825C8.02467 15.3417 6.53301 15 5.41634 15C4.41634 15 3.41634 15.125 2.49967 15.4167ZM17.4997 15.4167C16.583 15.125 15.583 15 14.583 15C13.4663 15 11.9747 15.3417 10.833 15.825V6.24167C11.9747 5.75 13.4663 5.41667 14.583 5.41667C15.583 5.41667 16.583 5.54167 17.4997 5.83333V15.4167Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.16667 6.24163C8.025 5.75829 6.53333 5.41663 5.41667 5.41663C4.41667 5.41663 3.41667 5.54163 2.5 5.83329V15.4166C3.41667 15.125 4.41667 15 5.41667 15C6.53333 15 8.025 15.3416 9.16667 15.825V6.24163Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5837 8.75C15.317 8.75 16.0253 8.825 16.667 8.96667V7.7C16.0087 7.575 15.3003 7.5 14.5837 7.5C13.517 7.5 12.5337 7.63333 11.667 7.89167V9.2C12.492 8.90833 13.4837 8.75 14.5837 8.75Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5837 10.9667C15.317 10.9667 16.0253 11.0417 16.667 11.1833V9.91667C16.0087 9.79167 15.3003 9.71667 14.5837 9.71667C13.517 9.71667 12.5337 9.85001 11.667 10.1083V11.4167C12.492 11.1333 13.4837 10.9667 14.5837 10.9667Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5837 13.1917C15.317 13.1917 16.0253 13.2667 16.667 13.4083V12.1417C16.0087 12.0167 15.3003 11.9417 14.5837 11.9417C13.517 11.9417 12.5337 12.075 11.667 12.3333V13.6417C12.492 13.35 13.4837 13.1917 14.5837 13.1917Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModulesad);
export default __webpack_public_path__ + "static/media/modulesad.e249e4c70cccc4f029cb519c2aaa957e.svg";
export { ForwardRef as ReactComponent };